import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GlobalDragStateService {
  private isDraggingSubject = new BehaviorSubject<boolean>(false);
  public isDragging$ = this.isDraggingSubject.asObservable();

  constructor() { }

  setDragging(isDragging: boolean): void {
    this.isDraggingSubject.next(isDragging);
  }

  get isDragging(): boolean {
    return this.isDraggingSubject.value;
  }
}
